import { render, staticRenderFns } from "./relationMaterial.vue?vue&type=template&id=3dcdffa4&scoped=true"
import script from "./relationMaterial.vue?vue&type=script&lang=js"
export * from "./relationMaterial.vue?vue&type=script&lang=js"
import style0 from "./relationMaterial.vue?vue&type=style&index=0&id=3dcdffa4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcdffa4",
  null
  
)

export default component.exports